import React, { useState } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import api from '../../api';
import { extractError } from '../../api/client';
import { formatMoney } from '../../utils/format';
import PageHeader from '../../components/common/PageHeader';
import Loader from '../../components/common/Loader';
import { showError } from '../../utils/alert';

const unwrap = (rows) => (rows && Array.isArray(rows.data) ? rows.data : rows || []);

const rowBlock = (title, rows, total) => (
  <div className="card" style={{ marginBottom: 18 }}>
    <div className="card-header"><div className="card-title">{title}</div></div>
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr><th>Account</th><th className="table-num">Amount</th></tr>
        </thead>
        <tbody>
          {unwrap(rows).map((r) => (
            <tr key={r.account_id || r.id || r.name}>
              <td>{r.name}</td>
              <td className="table-num">{formatMoney(r.amount || r.total)}</td>
            </tr>
          ))}
          {(!rows || rows.length === 0) && (
            <tr><td colSpan={2} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>No entries</td></tr>
          )}
          <tr style={{ background: '#f8fafc' }}>
            <td style={{ fontWeight: 700 }}>Total</td>
            <td className="table-num" style={{ fontWeight: 700 }}>{formatMoney(total)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default function IncomeStatement() {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data: res } = await api.reports.incomeStatement({ from: from || undefined, to: to || undefined });
      setData(res);
    } catch (err) {
      showError('Failed to load income statement', extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <PageHeader
        title="Income Statement"
        subtitle="Income, expenses and net profit for the period."
        crumbs={[{ label: 'Reports', to: '/reports' }, { label: 'Income Statement' }]}
      />

      <div className="card">
        <div className="card-body">
          <div className="filters-bar">
            <input className="form-control" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
            <input className="form-control" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
            <button className="btn btn-primary btn-sm" onClick={load}><FiRefreshCw /> Run</button>
          </div>
          {loading ? <Loader text="Loading income statement..." /> : null}

          {data && (
            <>
              <div className="stats-grid" style={{ marginBottom: 18 }}>
                <div className="stat-card"><div className="stat-icon green"><i className="bi bi-graph-up" /></div><div><div className="stat-value">{formatMoney(data.income?.total)}</div><div className="stat-label">Total Income</div></div></div>
                <div className="stat-card"><div className="stat-icon red"><i className="bi bi-graph-down" /></div><div><div className="stat-value">{formatMoney(data.expense?.total)}</div><div className="stat-label">Total Expenses</div></div></div>
                <div className="stat-card">
                  <div className={`stat-icon ${data.net_profit >= 0 ? 'indigo' : 'orange'}`}><i className="bi bi-cash-coin" /></div>
                  <div><div className="stat-value">{formatMoney(data.net_profit)}</div><div className="stat-label">Net Profit</div></div>
                </div>
              </div>
              {rowBlock('Income', data.income?.rows, data.income?.total)}
              {rowBlock('Expenses', data.expense?.rows, data.expense?.total)}
            </>
          )}
        </div>
      </div>
    </div>
  );
}